import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Code completion is bad mmkay",
  "description": "",
  "published": "2014-11-14T00:00:00.000Z",
  "redirect_from": ["/blog/code-completion-is-bad-mmkay/swizec/6618"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Everybody loves `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Autocomplete",
        "title": "Autocomplete"
      }}>{`code completion`}</a>{`. You type three characters instead of ten and save some time.`}</p>
    <p>{`Like, almost a second.`}</p>
    <p>{`Being glued to a keyboard most of your life means you can type at some 100 `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Words_per_minute",
        "title": "Words per minute"
      }}>{`words per minute`}</a>{`. With the average English word's length of 5.1 characters, this gives you 8.5 characters a second`}</p>
    <p>{`That's pretty fast. If you're a gamer, you're even faster. Hundreds of actions per second.`}</p>
    <p>{`Maaaaaaybe code completion adds up to `}<em parentName="p">{`minutes`}</em>{` a day. But you're spending most of your time thinking about and reading code, not typing. You are not a typist.`}</p>
    <p>{`But fine, code completion is cool. Except when it wastes `}<strong parentName="p">{`massive`}</strong>{` amounts of time.`}</p>
    <p>{`On Sunday I was adding some `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/JavaScript",
        "title": "JavaScript"
      }}>{`JavaScript`}</a>{` to a webpage using an `}<a parentName="p" {...{
        "href": "http://www.gnu.org/software/emacs",
        "title": "Emacs"
      }}>{`Emacs`}</a>{` mode that does simple code completion. When you write `}<inlineCode parentName="p">{`</`}</inlineCode>{` it fills out the rest.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<scrpt src="/js/some.js"></scrpt>
<script type="text/javascript">
  do_something();
</script>
`}</code></pre>
    <p>{`Refresh the page. Nothing happens.`}</p>
    <p>{`Hmm ... right.`}</p>
    <p>{`Add an alert into `}<inlineCode parentName="p">{`some.js`}</inlineCode>{` to make sure it loads. Nothing.`}</p>
    <p>{`Huh path is correct, I can see my code in the generated HTML. But it's not working.`}</p>
    <p>{`20 minutes pass.`}</p>
    <p>{`Idiot! `}<inlineCode parentName="p">{`script`}</inlineCode>{` not `}<inlineCode parentName="p">{`scrpt`}</inlineCode>{`!`}</p>
    <p>{`Change tag, file loads. YES!`}</p>
    <p>{`But the code in functions doesn't execute. The more alerts and console.logs I added, the more confused I was. No matter what I tried, code didn't execute. It was all there and there were no JavaScript errors.`}</p>
    <p>{`It just did not want to work.`}</p>
    <p>{`After an hour of this nonsense I was ready to throw my computer out the window and pick up gardening. Fuck everything.`}</p>
    <p>{`Ugh, the stupid close tag! `}<inlineCode parentName="p">{`<script>`}</inlineCode>{` and `}<inlineCode parentName="p">{`</scrpt>`}</inlineCode>{` don't match so `}<em parentName="p">{`obviously`}</em>{` the browser eats that whole embedded script tag.`}</p>
    <p>{`I am an idiot and I should feel bad. This was a stupid thing, but it wasted a lot of time and the code completion trained me never to think about closing tags.`}</p>
    <p>{`But this was silly. A much bigger code completion fuck up happened on a different project last week.`}</p>
    <p>{`Without giving too much detail, another programmer on the team implemented some new widgets and in a different part of the codebase I had to decide if a particular element was a widget or not.`}</p>
    <p>{`Something like having a class `}<inlineCode parentName="p">{`widget_this`}</inlineCode>{` or `}<inlineCode parentName="p">{`widget_that`}</inlineCode>{`.`}</p>
    <p>{`And then there was `}<inlineCode parentName="p">{`wdiget_that_too`}</inlineCode>{`.`}</p>
    <p><em parentName="p">{`Wdiget`}</em>{`. A `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Typographical_error",
        "title": "Typographical error"
      }}>{`typo.`}</a>{` Honest mistake, happens all the time. But code completion replicated the typo all over the place.`}</p>
    <p>{`He didn't even realise there was a typo because, hey, code completion. It's automagically doing the right thing is it not?`}</p>
    <p>{`Cleaning that up was a nuisance. But find&replace did the job.`}</p>
    <p>{`Except where it was now a data problem. We're saving that stuff to a database and aren't using proper enumerators. Tech stack doesn't make it easy and strings are Good Enough (tm).`}</p>
    <p>{`Now I suddenly can't reliably make the problem go away. It could have made it into any of the production databases, god knows when the typo will go away on customer facing deployments, and I sure as hell don't want to go through all the objects in all the mongo databases to fix the data.`}</p>
    <p>{`I resort to a `}<inlineCode parentName="p">{`if (something == 'widget' || something == 'wdiget')`}</inlineCode>{` and sob tears of despair.`}</p>
    <p>{`Eventually I will move on, but the codebase will not. That ugly if clause is going to be there forever. Every time somebody finds it, they will look into it, waste half an hour to an hour, decide the problem cannot be fixed reliably and leave it alone for the next schmuck to stumble into.`}</p>
    <p><strong parentName="p">{`Hours will be wasted`}</strong>{` for the lifetime of the project because some guy was too lazy to type 5 extra characters.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      